import React from "react";
import "../css/InputData.css";
import "../css/InputIconSearch.css";
import { inputOnEnter } from "../js/utils";
import { formatField } from "../js/format";

export default function InputIconSearch(props) {
  const inputRef = React.useRef();

  const getInputSize = () => {
    const sizeClass = {
      0: "input-full",
      1: "input-small",
      2: "input-medium",
      3: "input-large",
      4: "input-super-small",
      5: "input-super-small-2",
      6: "input-full-flex",
      7: "input-small-2",
    };
    return sizeClass[props.size] || "";
  };

  function handleKeyDown(event) {
    if (event.key === "Enter") {
      // Convertir a string y verificar si tiene contenido
      const inputValue = String(props.input || "").trim();

      event.preventDefault(); // Evita que salte al siguiente input
      if (props.onEnter) {
        props.onEnter();
      }
    }
  }

  return (
    <div
      className={`input-data input-icon-search ${getInputSize()} ${
        props.highlight ? "highlight" : ""
      } ${props.inactive ? "inactive-bkg" : ""}`}
    >
      <img
        src="/images/search-blue.svg"
        loading="lazy"
        width="14"
        height="14"
        alt="icon"
        className="input-icon-search-img"
      />
      <input
        ref={inputRef}
        tabIndex={props.tabIndex}
        id={props.id}
        type={props.type ? props.type : "text"}
        disabled={props.inactive}
        placeholder={props.placeholder}
        onChange={(e) => {
          const filtered = props.type
            ? formatField(e.target, e.target.value, props.type, false)
            : e.target.value.toUpperCase();
          props.onChange(filtered);
        }}
        onKeyDown={handleKeyDown}
        onKeyUp={(e) => {
          inputOnEnter(e);
        }}
        value={props.input}
      ></input>
      {props.input && (
        <img
          src="/images/close-dark.svg"
          loading="lazy"
          width="14"
          height="14"
          alt="icon"
          className="input-icon-search-clear"
          onClick={() => {
            props.onClear();
          }}
        />
      )}
    </div>
  );
}
